import FLEX from 'FLEX/js/client-namespace';
import HoverTile from "../components/component_hover_tile/hover-tile";
import Nav from "../components/component_nav/nav";

FLEX.ChildComponents = {
    'HoverTile': HoverTile,
    'Nav': Nav,
};

console.log('Child $ version: ', $.fn.jquery);